var render = function render(){var _vm=this,_c=_vm._self._c;return (this.params.value)?_c('div',{staticStyle:{"text-align":"right"}},[_vm._v("\r\n    "+_vm._s(this.params.value.toFixed(2))+" %\r\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }